import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { FiTrendingUp, FiSearch } from 'react-icons/fi';
import { stockService } from '../services/apiService';
import LoadingSpinner from '../components/LoadingSpinner';
import { formatCurrency, formatDateTime } from '../utils/formatters';

const Sales = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const { data, isLoading, error } = useQuery(
    'sales',
    () => stockService.getMovements({ movement_type: 'sale' }),
  );

  if (isLoading) return <LoadingSpinner message="Loading sales..." />;

  if (error) {
    return (
      <div className="empty-state">
        <FiTrendingUp size={48} />
        <h3>Failed to load sales</h3>
        <p>{error.message}</p>
      </div>
    );
  }

  const sales = data?.data || [];
  
  const filteredSales = sales.filter((sale) =>
    sale.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    sale.reference_id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalSales = sales.reduce(
    (sum, sale) => sum + Math.abs(sale.total_value || 0),
    0
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Sales</h1>
          <p className="page-subtitle">
            Total revenue: {formatCurrency(totalSales)}
          </p>
        </div>
      </div>

      <div className="search-bar">
        <FiSearch size={20} />
        <input
          type="text"
          placeholder="Search sales..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredSales.length === 0 ? (
        <div className="card">
          <div className="empty-state">
            <FiTrendingUp size={48} />
            <h3>No sales recorded yet</h3>
            <p>Sales made through the POS will appear here</p>
          </div>
        </div>
      ) : (
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total</th>
                <th>Reference</th>
              </tr>
            </thead>
            <tbody>
              {filteredSales.map((sale) => (
                <tr key={sale.movement_id}>
                  <td>{formatDateTime(sale.created_at)}</td>
                  <td>{sale.product_name}</td>
                  <td>
                    <span className="badge badge-info">
                      {Math.abs(sale.quantity)}
                    </span>
                  </td>
                  <td>{formatCurrency(sale.unit_price)}</td>
                  <td>
                    <strong>
                      {formatCurrency(Math.abs(sale.total_value))}
                    </strong>
                  </td>
                  <td>{sale.reference_id || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Sales;
